<template lang='pug'>
  .site-messages
    slot(v-bind:messages="messages")

</template>

<script>
  export default {
    props: {
      topics: String
    },

    data: function() {
      return {
        messages: []
      };
    },

    mounted() {
      var self = this;
      self.$http.get('/api/siteMessages/getByTopics', {
        params: {
          topics: self.topics
        }
      }).then(res => {
        self.messages = res.data;
      });
    }
  };
</script>
